import { useQuery, useMutation } from '@tanstack/react-query';
import { chatLogService, ChatLogsParams } from '../../../services/chatLogService';
import { showToast } from '../../../stores/uiStore';
import { handleApiError } from '../../../services/api';
import { useSessionGate } from '../../../hooks/useSessionGate';

export const useChatLogs = (domainId: string, params?: ChatLogsParams) => {
  const { expired } = useSessionGate();
  return useQuery({
    queryKey: ['chatLogs', domainId, params],
    queryFn: () => chatLogService.getChatLogs(domainId, params),
    enabled: !!domainId && !expired,
  });
};

export const useExportChatLogs = (domainId: string, domain: string) => {
  return useMutation({
    mutationFn: ({ from, to }: { from: string; to: string }) =>
      chatLogService.downloadChatLogs(domainId, from, to, domain),
    onSuccess: () => {
      showToast.success('チャット履歴をエクスポートしました');
    },
    onError: (error) => {
      const apiError = handleApiError(error);
      showToast.error(apiError.message);
    },
  });
};
